// extracted by mini-css-extract-plugin
export var typingIndicator = "_mp-0";